import {IIdentityUserService} from '@/services/identity/IIdentityUserService';
import {Inject, injectable} from 'inversify-props';

import {IApiService} from '@/services/IApi.service';

@injectable()
export class IdentityUserService implements IIdentityUserService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/identity/user';

  public setPassword(username: string, currentPassword: string, newPassword: string): Promise<void> {
    const data = {
      username,
      currentPassword,
      newPassword,
    };

    return this.apiService.post(`${this.path}/password`, data);
  }
}

